import type { WhereCategory, WhereDataset, WhereField } from '../types.js';
import { ACCOUNT_FIELDS } from './account.js';
import { CONTACT_FIELDS } from './contact.js';
import { PROJECT_FIELDS } from './project.js';

export const WHERE_FIELDS: Record<WhereDataset, readonly WhereField[]> = {
  account: ACCOUNT_FIELDS,
  project: PROJECT_FIELDS,
  contact: CONTACT_FIELDS,
};

export const BASE_CATEGORY: Record<WhereDataset, WhereCategory> = {
  account: 'firm',
  project: 'project',
  contact: 'contact',
};

export const SCORE_LABEL: Record<WhereDataset, string> = {
  account: 'ICP Score',
  project: 'Atlas Score',
  contact: 'Prospect Score',
};

const byKey = new Map(
  (Object.keys(WHERE_FIELDS) as WhereDataset[]).map((d) => [
    d,
    new Map(WHERE_FIELDS[d].map((f) => [f.key, f])),
  ]),
);

export function whereField(dataset: WhereDataset, key: string): WhereField | undefined {
  return byKey.get(dataset)?.get(key);
}
